import { TAvailability } from "../../types/types";

export const AvailabilityExcerpt = (props: { availability: TAvailability }) => {
    // console.log("AvailabilityExcerpt props: ", props);
    return (<div key={props.availability.lodging_name} className="availability-excerpt col-auto" onClick={() => null}>
        {props.availability.lodging_name}
    </div>);
};